import RouteEnum from '../enums/RouteEnum';

const MenuItems = [
    { label: 'Přehled', path: RouteEnum.INDEX() },
    { label: 'Strom', path: RouteEnum.STROM() },
    { label: 'FAQ', path: RouteEnum.FAQ() },
    { label: 'Zakázaná témata', path: RouteEnum.FORB() },
    { label: 'Small talk', path: RouteEnum.SMALLTALK() },
    { label: 'Konfigurace', path: RouteEnum.KONFIGURACE() },
    { label: 'Konverzace', path: RouteEnum.KONVERZACE() },
    { label: 'Správa uživatelů', path: RouteEnum.UZIVATEL_SEZNAM() },
];

export default MenuItems;
